const metricsTrack = (event, payload) => {
    const DL = window.dataLayer || [];
    const trackingData = Object.assign(Object.assign({ event }, payload), { dlv_clean_page_url: document.location.href, dlv_clean_page_path: window.location.pathname, lang: document.querySelector('html').lang });
    if (DL) {
        DL.push(trackingData);
    }
};

export { metricsTrack };
